<script lang="ts">

import {translate} from "$lib/i18n";
  interface Props {
    currentPage?: number;
    totalElements?: number;
    loading?: boolean;
    loadMore: () => void;
  }

  let {
    currentPage = 0,
    totalElements = 0,
    loading = false,
    loadMore
  }: Props = $props();

  let amountOfGames = $derived(Math.min(currentPage * 32, totalElements));
  let percentage = $derived(Math.min(Math.round(((currentPage * 32) / totalElements) * 100), 100));

</script>

{#if !loading}
  <div class="flex flex-col justify-center items-center mt-10">
    <div class="text-primary-lightBlue flex items-center">
      <span class="text-white">
        {amountOfGames}
      </span>
      /{totalElements}
      <div class="w-36 rounded-full bg-primary-lightBlue mx-2 h-4 overflow-hidden">
        <div class="h-4 rounded-full bg-primary-fire" style="width: {percentage}%"></div>
      </div>
      <span>{percentage}%</span>
    </div>
    <button hidden={amountOfGames  >= totalElements}
            class="bg-primary-lightBlue text-white py-2 px-4 rounded-full mt-4"
            onclick={loadMore}>
      {$translate('Load More')}
    </button>
  </div>
  {/if}
